import { render, staticRenderFns } from "./ReviewGate.vue?vue&type=template&id=582f3194&scoped=true"
import script from "./ReviewGate.vue?vue&type=script&lang=js"
export * from "./ReviewGate.vue?vue&type=script&lang=js"
import style0 from "./ReviewGate.vue?vue&type=style&index=0&id=582f3194&prod&lang=css"
import style1 from "./ReviewGate.vue?vue&type=style&index=1&id=582f3194&prod&lang=scss&scoped=true"
import style2 from "./ReviewGate.vue?vue&type=style&index=2&id=582f3194&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582f3194",
  null
  
)

export default component.exports